import { createUseStyles } from 'react-jss';

import { variantMapping } from '../../../components/Typography/constants';
import styling from '../../../services/styling';

export default createUseStyles(
  {
    image: {
      height: 276,
      marginBottom: 30,
      [styling.breakpoints.up('md')]: {
        height: 589,
        marginBottom: 64,
      },
    },
    videoWrapper: {
      position: 'relative',
      height: 276,
      marginBottom: 30,
      overflow: 'hidden',
      [styling.breakpoints.up('md')]: {
        height: 589,
        marginBottom: 64,
      },
    },
    videoInner: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
    },
    loading: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    body: {
      maxWidth: 662,
      margin: [0, 'auto', 36],
      textAlign: 'center',
      '& a': {
        ...variantMapping.link.styles,
        fontSize: 'inherit',
        lineHeight: 'inherit',
        textDecoration: 'underline',
      },
    },
    buttonWrapper: {
      maxWidth: 782,
      margin: [0, 'auto', 50],
      textAlign: 'center',
    },
    button: {
      display: 'inline-block',
      paddingRight: 48,
      paddingLeft: 48,
    },
    disclaimer: {
      maxWidth: 782,
      margin: [0, 'auto', 140],
      textAlign: 'center',
    },
  },
  { name: 'homeFullBleed' },
);
